import { TrashIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { ConfirmationModal } from 'features/kestrelViewer/ui/popupMenu/shared/ConfirmationModal'
import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { KVAnnotation, RolodexEntryPatchJson } from 'types'

const StyledTrashIcon = styled(TrashIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const DeleteAnnotationButton: FC<{
  annotationId: string
}> = ({ annotationId }) => {
  const {
    sendKVCommand,
    selectedMarkup,
    setSelectedMarkup,
    kestrelModel,
    annotations,
    setAnnotations,
  } = useKestrel()
  const { rolodexPatch } = useRolodexEdit()
  const [showConfirm, setShowConfirm] = useState(false)

  const annotation = annotations?.find((a) => a.id === annotationId)
  const annotationLabel = annotation?.label || 'this annotation'

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setShowConfirm(true)
  }

  const handleConfirm = () => {
    let filteredAnnotations: KVAnnotation[] = []
    if (annotations) {
      filteredAnnotations = annotations.filter((a) => a.id !== annotationId)
    }
    if (sendKVCommand) {
      setAnnotations(filteredAnnotations)
      if (annotation?.geometry?.kind === 'point') {
        sendKVCommand({
          command: KestrelCommands.DELETE_ANNOTATION,
          annotationId: annotationId,
        })
      } else if (annotation?.geometry?.kind === 'polygon') {
        sendKVCommand({
          command: KestrelCommands.DELETE_SURFACE_AREA,
          surfaceAreaId: annotationId,
        })
      }
      if (selectedMarkup?.id === annotationId) setSelectedMarkup(undefined)

      const patchData: RolodexEntryPatchJson = {
        id: kestrelModel?.id ?? '',
        data: {
          annotations:
            filteredAnnotations?.map((a) => KVAnnotation.toJSON(a)) ?? [],
        },
      }
      rolodexPatch([patchData])
    }
    setShowConfirm(false)
  }

  const handleCancel = () => {
    setShowConfirm(false)
  }

  return (
    <>
      <TooltipWrapper label='Delete annotation' side='top'>
        <div
          style={{ cursor: 'pointer', marginLeft: '-4px' }}
          onClick={handleClick}>
          <StyledTrashIcon width={22} height={22} />
        </div>
      </TooltipWrapper>

      <ConfirmationModal
        isOpen={showConfirm}
        title='Delete Annotation'
        message={`Are you sure you want to delete "${annotationLabel}"? This action cannot be undone.`}
        confirmText='Delete'
        cancelText='Cancel'
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  )
}
